<div #maincontainer class="main-container report">
    <mat-progress-bar *ngIf="this.isLoadingMoreRecords" mode="indeterminate" class="progress-fixed"></mat-progress-bar>
    <div class="row table-header z-depth-1 hide-on-med-and-down">
        <div class="header-items">
            <div class="col l2 m5 s5 input-field">
                <mat-form-field appearance="fill">
                    <mat-label>Report</mat-label>
                    <mat-select id="reportName" name="reportName" [(ngModel)]="reportParams.reportName">
                        <mat-option *ngFor="let r of objectKeys(reports); let i=index" [value]="r">
                            {{ reports[r] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="!IsMasterReport" class="col l2 m5 s5 input-field">
                <mat-form-field appearance="fill">
                    <mat-label>End Credits</mat-label>
                    <mat-select id="restrictionType" [(ngModel)]="reportParams.restrictionType">
                        <mat-option *ngFor="let restr of restrictionsLookup" [value]="restr.name">{{restr.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="IsMasterReport" class="col l3 m7 s7 input-field">
                <mat-form-field appearance="fill">
                    <mat-label>Filter by Status</mat-label>
                    <mat-select id="status" [(ngModel)]="reportParams.status" (selectionChange)="refreshParams($event)">
                        <mat-option *ngFor="let stat of statusLookup" [value]="stat.name">{{stat.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="IsMasterReport" class="col l2 m5 s5 input-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sort By</mat-label>
                    <mat-select id="sortedBy" name="sortedBy" [(ngModel)]="reportParams.sortedBy" (selectionChange)="filterChanged('sortedBy')">
                        <mat-option value=""></mat-option>
                        <mat-option value="Status">Status</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="IsMasterReport" class="col l2 m5 s5 input-field">
                <mat-form-field appearance="fill">
                    <mat-label>Search By</mat-label>
                    <mat-select id="searchBy" name="searchBy" [(ngModel)]="reportParams.searchBy" (selectionChange)="filterChanged('searchBy')">
                        <mat-option value="All">All</mat-option>
                        <mat-option value="Name">Name</mat-option>
                        <mat-option value="Number">Number</mat-option>
                        <mat-option value="Copyright/Owner">Copyright/Owner</mat-option>
                        <mat-option value="Artist Author">Artist/Author</mat-option>
                        <mat-option value="Season">Season</mat-option>
                        <mat-option value="Episode">Episode</mat-option>
                        <mat-option value="Tags">Tags</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="IsMasterReport" class="col l3 m7 s7">
                <div class="col l11 m11 s11 input-field">
                    <mat-form-field *ngIf="reportParams.searchBy != 'All'" appearance="fill">
                        <mat-label>Search</mat-label>
                        <input matInput type="text" id="searchByValue" name="searchByValue" [(ngModel)]="reportParams.searchByValue" />
                    </mat-form-field>
                </div>
                <div *ngIf="reportParams.searchBy != 'All'" class="col l1 m1 s1 clear-icon">
                    <a class="anchor" (click)="filterChanged('clear')">
                        <i class="material-icons left" matTooltip="clear search" matTooltipPosition="above">clear</i></a>
                </div>
            </div>
            <div class="col l12 tags-header" *ngIf="IsMasterReport && !IsMobile">
                <div class="switch col l3 m6 s12">
                    <span class="switch-label">Filter Tags</span>
                    <span class="switch-option switch-option-no">No</span>
                    <mat-slide-toggle name="isCreatedByProd" tabindex="3" [(ngModel)]="includeAllTags"
                        id="includeAllTags" #filterTagsCheck (change)="onIncludeAllTagsChanged($event.checked)"
                        aria-label="Filter Tags">
                    </mat-slide-toggle>
                    <span class="switch-option switch-option-yes">Yes</span>
                </div>
                <div class="row tag-items col l9 m6 s12">
                    <clearanceItem-tag #tagComponent *ngIf="!IsMobile" [globalTags]="globalTags"
                        [projectId]="reportParams.projectId" (newTagAdded)="newTagAdded($event)"
                        [canTagsBeToggled]="true" [allowCreateTag]="false"></clearanceItem-tag>
                    <label class="center"
                        *ngIf="includeAllTags && !isLoadingFilterTags && globalTags.length === 0">No tags exist under
                        the current criteria</label>
                </div>
            </div>
            <div class="col l12 tags-header" *ngIf="IsMasterReport && !IsMobile" style="padding-bottom:0px;margin-bottom: 0px;">
                <div class="row col l3 m6 s12">
                    <div class="switch">
                        <span class="switch-label">Custom Header</span>
                        <span class="switch-option switch-option-no">No</span>
                        <mat-slide-toggle name="customHeaderCheck" tabindex="3"
                            [(ngModel)]="reportParams.isCustomHeaderSelected" id="customHeaderCheck" #customHeaderCheck
                            (change)="onCustomHeaderSelectionChanged(customHeaderCheck.checked)"
                            aria-label="Custom Header">
                        </mat-slide-toggle>
                        <span class="switch-option switch-option-yes">Yes</span>
                    </div>
                    <div class="form-group input-field" *ngIf="reportParams.isCustomHeaderSelected">
                        <mat-form-field appearance="fill">
                            <mat-label>As of date</mat-label>
                            <input matInput [matDatepicker]="desktopDatePicker" id="asOfDate" [(ngModel)]="reportParams.asOfDate">
                            <mat-datepicker-toggle matSuffix [for]="desktopDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #desktopDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="input-field col l9 m6 s12" *ngIf="reportParams.isCustomHeaderSelected">
                    <mat-form-field appearance="fill" class="custom-header-field">
                        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" tabindex="4" id="customHeader" name="customHeader"
                            [(ngModel)]="reportParams.customHeader"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="col l12 action-items right-align">
                <button *ngIf="IsMasterReport" type="button" mat-button matTooltip="Clear Report Parameters" matTooltipPosition="below" (click)="clearParameters()">Clear</button>
                <button type="button" mat-button matTooltip="Generate Reports" matTooltipPosition="below" (click)="generateReports()">Generate</button>
                <button type="button" mat-button matTooltip="Refresh Reports" matTooltipPosition="below" (click)="refreshReportsList()">
                    Refresh
                </button>
            </div>
        </div>
    </div>
    <mat-accordion class="table-header-mobile show-on-medium-and-down hide-on-large-only">
        <mat-expansion-panel [expanded]="mobileFiltersExpanded" hideToggle>
            <mat-expansion-panel-header class="reports-mobile-filter-header">
                <mat-panel-title class="reports-mobile-filter-title"></mat-panel-title>
                <mat-panel-description class="reports-mobile-filter-icon">
                    <i class="material-icons">search</i>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row">
                <div class="col l2 m5 s5 input-field">
                    <mat-form-field appearance="fill">
                        <mat-label>Report</mat-label>
                        <mat-select id="reportNameMobile" name="reportNameMobile" [(ngModel)]="reportParams.reportName">
                            <mat-option *ngFor="let r of objectKeys(reports); let i=index" [value]="r">{{ reports[r] }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="!IsMasterReport" class="col l2 m5 s5 input-field">
                    <mat-form-field appearance="fill">
                        <mat-label>End Credits</mat-label>
                        <mat-select id="restrictionTypeMobile" [(ngModel)]="reportParams.restrictionType">
                            <mat-option *ngFor="let restr of restrictionsLookup" [value]="restr.name">{{restr.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="IsMasterReport" class="col l3 m6 s12 input-field">
                    <mat-form-field appearance="fill">
                        <mat-label>Filter by Status</mat-label>
                        <mat-select id="statusMobile" [(ngModel)]="reportParams.status" (selectionChange)="refreshParams($event)">
                            <mat-option *ngFor="let stat of statusLookup" [value]="stat.name">{{stat.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="IsMasterReport" class="col l2 m6 s12 input-field">
                    <mat-form-field appearance="fill">
                        <mat-label>Sort By</mat-label>
                        <mat-select id="sortedByMobile" name="sortedByMobile" [(ngModel)]="reportParams.sortedBy" (selectionChange)="filterChanged('sortedBy')">
                            <mat-option value=""></mat-option>
                            <mat-option value="Status">Status</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="IsMasterReport" class="col l2 m6 s12 input-field">
                    <mat-form-field appearance="fill">
                        <mat-label>Search By</mat-label>
                        <mat-select id="searchByMobile" name="searchByMobile" [(ngModel)]="reportParams.searchBy" (selectionChange)="filterChanged('searchBy')">
                            <mat-option value="All">All</mat-option>
                            <mat-option value="Name">Name</mat-option>
                            <mat-option value="Number">Number</mat-option>
                            <mat-option value="Copyright">Copyright/Owner</mat-option>
                            <mat-option value="ArtistAuthor">Artist/Author</mat-option>
                            <mat-option value="Season">Season</mat-option>
                            <mat-option value="Episode">Episode</mat-option>
                            <mat-option value="Tags">Tags</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="IsMasterReport" class="col l5 m6 s12">
                    <div class="col l11 m11 s11 input-field">
                        <mat-form-field *ngIf="reportParams.searchBy != 'All'" appearance="fill">
                            <mat-label>Search</mat-label>
                            <input matInput type="text" id="searchByValueMobile" name="searchByValueMobile" [(ngModel)]="reportParams.searchByValue" />
                        </mat-form-field>
                    </div>
                    <div class="col l1 m1 s1 clear-icon" *ngIf="reportParams.searchBy != 'All'">
                        <a class="anchor" (click)="filterChanged('clear')">
                            <i class="material-icons left" matTooltip="clear search" matTooltipPosition="below">clear</i></a>
                    </div>
                </div>
                <div class="col l12 tags-header" *ngIf="IsMasterReport && IsMobile">
                    <div class="switch col l3 m6 s12">
                        <span class="switch-label">Filter Tags</span>
                        <span class="switch-option switch-option-no">No</span>
                        <mat-slide-toggle name="isCreatedByProdMobile" tabindex="3" [(ngModel)]="includeAllTags"
                            id="includeAllTagsMobile" #filterTagsCheck (change)="onIncludeAllTagsChanged($event.checked)"
                            aria-label="Filter Tags">
                        </mat-slide-toggle>
                        <span class="switch-option switch-option-yes">Yes</span>
                    </div>
                    <div class="row tag-items col l9 m6 s12">
                        <clearanceItem-tag #tagComponent *ngIf="IsMobile" [globalTags]="globalTags"
                            [projectId]="projectId" (newTagAdded)="newTagAdded($event)" [canTagsBeToggled]="true">
                        </clearanceItem-tag>
                        <label class="center"
                            *ngIf="includeAllTags && !isLoadingFilterTags && globalTags.length === 0">No tags exist
                            under the current criteria</label>
                    </div>
                </div>
                <div class="col l12 m12 tags-header" *ngIf="IsMasterReport && IsMobile">
                    <div class="col l3 m6 s12">
                        <div class="row switch">
                            <span class="switch-label">Custom Header</span>
                            <span class="switch-option switch-option-no">No</span>
                            <mat-slide-toggle name="customHeaderCheckMobile" tabindex="3"
                                [(ngModel)]="reportParams.isCustomHeaderSelected" id="customHeaderCheckMobile"
                                #customHeaderCheck (change)="onCustomHeaderSelectionChanged(customHeaderCheck.checked)"
                                aria-label="Custom Header">
                            </mat-slide-toggle>
                            <span class="switch-option switch-option-yes">Yes</span>
                        </div>
                        <div class="form-group input-field" *ngIf="reportParams.isCustomHeaderSelected">
                            <mat-form-field appearance="fill">
                                <mat-label>As of date</mat-label>
                                <input matInput [matDatepicker]="mobileDatePicker" id="asOfDateMobile" [(ngModel)]="reportParams.asOfDate">
                                <mat-datepicker-toggle matSuffix [for]="mobileDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #mobileDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row col l9 m6 s12" *ngIf="reportParams.isCustomHeaderSelected">
                        <mat-form-field appearance="fill" class="custom-header-field">
                            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" tabindex="4" id="customHeaderMobile" name="customHeaderMobile" [(ngModel)]="reportParams.customHeader"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row center">
                    <div class="col m12 s12 action-items right-align">
                        <button *ngIf="IsMasterReport" type="button" mat-button (click)="clearParameters()">Clear</button>
                        <button type="button" mat-button (click)="generateReports()">Generate</button>
                        <button type="button" mat-button (click)="refreshReportsList()">Refresh</button>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
    <div class="row report-results show-on-medium-and-down hide-on-large-only">
        <div *ngIf="reportParams.reports.length <=0 " class="row subheader animated bounceInDown">No reports have been
            generated for this project yet</div>
        <div class="col s12 m6 l3" *ngFor="let report of reportParams.reports">
            <div class="card">
                <div class="card-content">
                    <div class="row">
                        <div class="card-title">
                            <span>{{ reports[report.reportName]}}</span>
                            <a *ngIf="report.errorMessage" class="anchor right" (click)="reportItemClicked(report)" matTooltip="failed" matTooltipPosition="above">
                                <i class="material-icons disabled error">error</i>
                            </a>
                            <a *ngIf="!report.errorMessage && report.reportUrl" class="anchor right"
                                (click)="reportItemClicked(report)" matTooltip="download" matTooltipPosition="above">
                                <i class="material-icons ">file_download</i>
                            </a>
                            <a *ngIf="!report.errorMessage && !report.reportUrl" class="anchor right"
                                (click)="reportItemClicked(report)" matTooltip="processing" matTooltipPosition="above">
                                <i class="material-icons rotating disabled">loop</i>
                            </a>
                        </div>
                        <div *ngIf="!report.IsCIListReport" class="report-params">&nbsp;</div>
                        <div *ngIf="report.IsCIListReport" class="report-params">SortBy: {{report.sortedBy}}
                            <span>-</span>{{report.sortDirection}}</div>
                        <div *ngIf="!report.IsEndCreditsReport" class="report-params">Status: {{report.status}}</div>
                        <div *ngIf="!report.IsEndCreditsReport" class="report-params">Search by: {{report.searchBy}}
                            <span *ngIf="report.searchByValue">-</span>{{!report.searchByValue?'All':report.searchByValue}}
                        </div>
                        <div *ngIf="report.IsEndCreditsReport" class="report-params">&nbsp;</div>
                        <div *ngIf="report.IsEndCreditsReport" class="report-params">Restriction Type:
                            {{report.restrictionType}}</div>
                        <div class="report-creator-name">{{report.createdBy}} <span
                                class="report-date">{{report.createdDate}}</span></div>
                        <div class="report-creator-name" *ngIf="!_authService.readOnly">
                            <a class="anchor right" (click)="openDeleteConfirmationModal(report)" matTooltip="Delete Report" matTooltipPosition="above">
                                <i class="material-icons right">delete</i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row report-results" id="cardListDivContainer">
        <div *ngIf="reportParams.reports.length <=0 " class="row subheader animated bounceInDown">No reports have been
            generated for this project yet</div>
        <div class="col s12 m6 l3" *ngFor="let report of reportParams.reports">
            <div class="card">
                <div class="card-content" (mouseenter)="setToolTipDelay()">
                    <div class="row">
                        <div class="card-title">
                            <span>{{ reports[report.reportName]}}</span>
                            <a *ngIf="report.errorMessage" class="anchor right" (click)="reportItemClicked(report)" matTooltip="failed" matTooltipPosition="above">
                                <i class="material-icons disabled error">error</i>
                            </a>
                            <a *ngIf="!report.errorMessage && report.reportUrl" class="anchor right" (click)="reportItemClicked(report)" matTooltip="download" matTooltipPosition="above">
                                <i class="material-icons ">file_download</i>
                            </a>
                            <a *ngIf="!report.errorMessage && !report.reportUrl" class="anchor right" (click)="reportItemClicked(report)" matTooltip="processing" matTooltipPosition="above">
                                <i class="material-icons rotating disabled">loop</i>
                            </a>
                        </div>
                        <div *ngIf="!report.IsCIListReport" class="report-params">&nbsp;</div>
                        <div *ngIf="report.IsCIListReport" class="report-params">SortBy: {{report.sortedBy}}
                            <span>- </span>{{report.sortDirection}}</div>
                        <div *ngIf="!report.IsEndCreditsReport" class="report-params" [matTooltip]="report.status" matTooltipPosition="below">Status: {{report.status}}</div>
                        <div *ngIf="!report.IsEndCreditsReport" class="report-params" [matTooltip]="!report.searchByValue ? 'All' : report.searchByValue" matTooltipPosition="below" >Search by: {{report.searchBy}}
                            <span *ngIf="report.searchByValue && report.searchBy">-</span>{{!report.searchByValue?'All':report.searchByValue}}
                        </div>
                        <div *ngIf="report.IsEndCreditsReport" class="report-params">&nbsp;</div>
                        <div *ngIf="report.IsEndCreditsReport" class="report-params">Restriction Type:
                            {{report.restrictionType}}</div>
                        <div class="report-creator-name">{{report.createdBy}} <span
                                class="report-date">{{report.createdDate}}</span></div>
                        <div class="report-creator-name" *ngIf="!_authService.readOnly">
                            <a class="anchor right" (click)="openDeleteConfirmationModal(report)" matTooltip="Delete Report" matTooltipPosition="above">
                                <i class="material-icons right">delete</i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isLoadingMoreRecords" class="loading-more">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <h4>Loading More Items...</h4>
    </div>
</div>

<div class="fixed-action-btn-over-footer" *ngIf="moreRecords()">
    <button type="button" mat-fab class="fab-load-more"
        (click)="manualLoad()" matTooltip="load more..." matTooltipPosition="above">
        <mat-icon>expand_more</mat-icon>
    </button>
</div>